// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 50px;
  padding: 20px 18px 50px;
  margin: 0;
  background-color: rgb(49,47,48);
  position: relative;
}

.footer__info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-end;
  align-items: flex-end;
}

.footer__text {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 25px;
  color: rgb(208,205,193);
  text-align: end;
  margin: 0;
}

.footer__phone {
  font-size: 18px;
  font-weight: 400;
  color: rgb(49,47,48);
  text-decoration: none;
  display: flex;
  justify-content: flex-end;
}

.footer-logo {
  height: 200px;
}

.footer__link {
  position: absolute;
  left: 18px;
  bottom: 50px;
}

.footer__vk {
  height: 20px;
}

@media screen and (max-width: 1100px) {
  .footer-logo {
    height: 150px;
  }

  .footer__text {
    font-size: 12px;
    line-height: 16px;
  }

  .footer__vk {
    height: 15px;
  }
}

@media screen and (max-width: 910px) {
  .footer {
    gap: 30px;
    padding-bottom: 30px;
  }

  .footer__link {
    bottom: 30px;
  }
}

@media screen and (max-width: 700px) {
  .footer {
    flex-direction: column;
    align-items: flex-end;
    gap: 30px;
    padding-top: 30px;
    padding-bottom: 50px;
  }

  .footer__link {
    bottom: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".footer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 50px;\r\n  padding: 20px 18px 50px;\r\n  margin: 0;\r\n  background-color: rgb(49,47,48);\r\n  position: relative;\r\n}\r\n\r\n.footer__info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n}\r\n\r\n.footer__text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  color: rgb(208,205,193);\r\n  text-align: end;\r\n  margin: 0;\r\n}\r\n\r\n.footer__phone {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: rgb(49,47,48);\r\n  text-decoration: none;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.footer-logo {\r\n  height: 200px;\r\n}\r\n\r\n.footer__link {\r\n  position: absolute;\r\n  left: 18px;\r\n  bottom: 50px;\r\n}\r\n\r\n.footer__vk {\r\n  height: 20px;\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .footer-logo {\r\n    height: 150px;\r\n  }\r\n\r\n  .footer__text {\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n  }\r\n\r\n  .footer__vk {\r\n    height: 15px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .footer {\r\n    gap: 30px;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .footer__link {\r\n    bottom: 30px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .footer {\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    gap: 30px;\r\n    padding-top: 30px;\r\n    padding-bottom: 50px;\r\n  }\r\n\r\n  .footer__link {\r\n    bottom: 50px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
